import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Cart} from '../orderSingletone/Cart';
import {Order} from '../orderSingletone/Order';
import {UiService} from '../../services/ui-service/ui.service';
import {MatStepper} from '@angular/material';
import {DressesService} from '../../services/dresses/dresses.service';
import {ApiService} from '../../services/api-service/api.service';
import * as $ from 'jquery';
import * as moment from 'moment';
// import {FormControl, FormArray,} from '@angular/forms';
import { CountdownComponent } from 'ngx-countdown';
import {FormControl} from '@angular/forms';
declare let fbq:Function;


declare let LiqPayCheckout: any;
import LiqPayCheckout from 'src/assets/js/checkout.js';

@Component({
  selector: 'app-reservation-form',
  templateUrl: './reservation-form.component.html',
  styleUrls: ['./reservation-form.component.scss'],
})


export class ReservationFormComponent implements OnInit, OnDestroy {

  disableSelect = new FormControl(false);

  public staticUrl = this.apiService.static_link;
  public cart = Cart.getInstance();
  private checkedCheckboxes = [];
  public formedOrder: Order;
  public selectedDresses = [];
  private dressesCost = 0;
  private dressesCostOld = 0;
  public total = 0;
  public outOfWorksTotal = 0;
  public rulesAccepted = false;
  public paymentChosen = false;
  public copy = [];
  public newTotal = 0;
  public selectedNumberOfPerson = 9;
  public selectedDressingRoom = 47;

  public payMessage = '';
  public orderNumber = 0;
  public paymentMethod = 1;
  public hiddeOrderNum  = false;
  public errorDateMsg = 'Виберіть дату зйомки';
  public errorTimeMsg = 'Виберіть час зйомки';
  public errorDate = false;
  public errorTime = false;

  @ViewChild('stepper') stepper: MatStepper;
  @ViewChild(CountdownComponent) counter: CountdownComponent;

  stepControlOne: FormGroup;
  stepControlTwo: FormGroup;
  stepControlThree: FormGroup;
  stepControlFour: FormGroup;

  subFormGroupOne: FormGroup;
  subFormGroupTwo: FormGroup;
  subFormGroupThree: FormGroup;
  subFormGroupFour: FormGroup;

  halls = [];
  options = [];

  timesUnavaliable = [];

  times = [
    {
      val: '08:00 - 09:00',
      status: true,
      checked: false,
      index: 0,
      subPrice: 0,
    },
    {
      val: '09:00 - 10:00',
      status: true,
      checked: false,
      index: 1,
      subPrice: 0,
    },
    {
      val: '10:00 - 11:00',
      status: true,
      checked: false,
      index: 2,
      subPrice: 0,
    },
    {
      val: '11:00 - 12:00',
      status: true,
      checked: false,
      index: 3,
      subPrice: 0,
    },
    {
      val: '12:00 - 13:00',
      status: true,
      checked: false,
      index: 4,
      subPrice: 0,
    },
    {
      val: '13:00 - 14:00',
      status: true,
      checked: false,
      index: 5,
      subPrice: 0,
    },
    {
      val: '14:00 - 15:00',
      status: true,
      checked: false,
      index: 6,
      subPrice: 0,
    },
    {
      val: '15:00 - 16:00',
      status: true,
      checked: false,
      index: 7,
      subPrice: 0,
    },
    {
      val: '16:00 - 17:00',
      status: true,
      checked: false,
      index: 8,
      subPrice: 0,
    },
    {
      val: '17:00 - 18:00',
      status: true,
      checked: false,
      index: 9,
      subPrice: 0,
    },
    {
      val: '18:00 - 19:00',
      status: true,
      checked: false,
      index: 10,
      subPrice: 0,
    },
    {
      val: '19:00 - 20:00',
      status: true,
      checked: false,
      index: 11,
      subPrice: 0,
    },
    {
      val: '20:00 - 21:00',
      status: true,
      checked: false,
      index: 12,
      subPrice: 0,
    },
    {
      val: '21:00 - 22:00',
      status: true,
      checked: false,
      index: 13,
      subPrice: 150,
    },
    {
      val: '22:00 - 23:00',
      status: true,
      checked: false,
      index: 14,
      subPrice: 150,
    },
    {
      val: '23:00 - 00:00',
      status: true,
      checked: false,
      index: 15,
      subPrice: 150,
    },
    {
      val: '00:00 - 01:00',
      status: true,
      checked: false,
      index: 16,
      subPrice: 150,
    },
    {
      val: '01:00 - 02:00',
      status: false,
      checked: false,
      index: 17,
      subPrice: 150,

    },
    {
      val: '02:00 - 03:00',
      status: true,
      checked: false,
      index: 18,
      subPrice: 150,

    },
    {
      val: '03:00 - 04:00',
      status: true,
      checked: false,
      index: 19,
      subPrice: 150,
    },
    {
      val: '04:00 - 05:00',
      status: false,
      checked: false,
      index: 20,
      subPrice: 150,
    },
    {
      val: '05:00 - 06:00',
      status: true,
      checked: false,
      index: 21,
      subPrice: 150,
    },
    {
      val: '06:00 - 07:00',
      status: true,
      checked: false,
      index: 22,
      subPrice: 150,
    },
    {
      val: '07:00 - 08:00',
      status: true,
      checked: false,
      index: 23,
      subPrice: 150,
    },
  ];

  extras = {
    lightSources: [
      // {
      //   title: 'Естественный',
      //   price: 0,
      //   index: 7,
      //   checked: false

      // },
      {
        title: 'Імпульсний',
        price: 0,
        index: 4,
        checked: false
      },
      {
        title: 'Постійний',
        price: 0,
        index: 5,
        checked: false

      }
    ],
    dressingRoom: [
      {
        title: 'Без гримерної',
        price: 0,
        index: 47,
        checked: false,
        description: 'Гримерна',
      },
      {
        title: '+1 год.',
        price: 100,
        index: 34,
        checked: false,
        description: 'Гримерна',
      },
      {
        title: '+2 год.',
        price: 200,
        index: 35,
        checked: false,
        description: 'Гримерна',
      },
      {
        title: '+3 год.',
        price: 300,
        index: 36,
        checked: false,
        description: 'Гримерна',
      },
      {
        title: '+4 год.',
        price: 400,
        index: 37,
        checked: false,
        description: 'Гримерна',
      },
      {
        title: '+5 год.',
        price: 500,
        index: 38,
        checked: false,
        description: 'Гримерна',
      },
      {
        title: '+6 год.',
        price: 600,
        index: 39,
        checked: false,
        description: 'Гримерна',
      },
      {
        title: '+7 год.',
        price: 700,
        index: 40,
        checked: false,
        description: 'Гримерна',
      },
      {
        title: '+8 год.',
        price: 800,
        index: 41,
        checked: false,
        description: 'Гримерна',
      },
      {
        title: '+9 год.',
        price: 900,
        index: 42,
        checked: false,
        description: 'Гримерна',
      },
      {
        title: '+10 год.',
        price: 1000,
        index: 43,
        checked: false,
        description: 'Гримерна',
      },
      {
        title: '+11 год.',
        price: 1100,
        index: 44,
        checked: false,
        description: 'Гримерна',
      },
      {
        title: '+12 год.',
        price: 1200,
        index: 45,
        checked: false,
        description: 'Гримерна',
      },
    ],

    /*  9 - 33*/
    numberOfPersons: [
      {
        title: '1',
        price: 0,
        index: 9,
        checked: null
      },
      {
        title: '2',
        price: 0,
        index: 10,
        checked: null

      },
      {
        title: '3',
        price: 0,
        index: 11,
        checked: null

      },
      {
        title: '4',
        price: 0,
        index: 12,
        checked: null

      },
      {
        title: '5',
        price: 0,
        index: 13,
        checked: null

      },
      {
        title: '6',
        price: 100,
        index: 14,
        checked: null

      },
      {
        title: '7',
        price: 200,
        index: 15,
        checked: null
      },
      {
        title: '8',
        price: 300,
        index: 16,
        checked: null

      },
      {
        title: '9',
        price: 400,
        index: 17,
        checked: null

      },
      {
        title: '10',
        price: 500,
        index: 18,
        checked: null

      },
      {
        title: '11',
        price: 600,
        index: 19,
        checked: null

      },
      {
        title: '12',
        price: 700,
        index: 20,
        checked: null

      },
      {
        title: '13',
        price: 800,
        index: 21,
        checked: null

      },
      {
        title: '14',
        price: 900,
        index: 22,
        checked: null

      },
      {
        title: '15',
        price: 1000,
        index: 23,
        checked: null

      },
      {
        title: '16',
        price: 1100,
        index: 24,
        checked: null
      },
      {
        title: '17',
        price: 1200,
        index: 25,
        checked: null

      },
      {
        title: '18',
        price: 1300,
        index: 26,
        checked: null

      },
      {
        title: '19',
        price: 1400,
        index: 27,
        checked: null

      },
      {
        title: '20',
        price: 1500,
        index: 28,
        checked: null

      },
      {
        title: '21',
        price: 1600,
        index: 29,
        checked: null

      },
      {
        title: '22',
        price: 1700,
        index: 30,
        checked: null

      },
      {
        title: '23',
        price: 1800,
        index: 31,
        checked: null
      },
      {
        title: '24',
        price: 1900,
        index: 32,
        checked: null

      },
      {
        title: '25',
        price: 2000,
        index: 33,
        checked: null
      },
      {
        title: 'Рассчитать на месте',
        price: 0,
        index: 34,
        checked: null
      },
    ],
    bathFilling: [
      {
        title: 'Замовити',
        price: 300,
        index: 0,
        checked: false

      }
    ]
  };

  goBack = (): void => {
    if (this.stepper.selectedIndex === 1) {
      let checkboxes = Array.from(document.getElementsByClassName('hall-checkbox'));
      for (let item of checkboxes) {
        (item as HTMLInputElement).checked = false;
      }
      // this.formedOrder.setSelectedDate(this.stepControlTwo.get('selectedDate').value);
      this.stepControlTwo.get('selectedDate').setValue(null);
      this.stepControlOne.get('selectedHall').setValue(null);
      this.resetForm();
      this.total = this.getExtras();
    }
    this.stepper.previous();
  }
  goForward = (): void => {
    this.stepper.next();
    if(this.stepper.selectedIndex === 4) {
      fbq('track', 'AddPaymentInfo');
    }
  }
  moveToStep = (index) => {
    this.stepper.selectedIndex = index;
  }

  getUnavaliableTimes = (event) => {
    let time = event['value'].format('DDMMYYYY');
      if(this.stepControlOne.get('selectedHall').value !== null){
        this.apiService.getTimesUnavaliable(time, this.stepControlOne.get('selectedHall').value['product_id']).subscribe(value => {
          this.timesUnavaliable = value;
        });
      } else {
        this.apiService.getTimesUnavaliable(time, this.cart.order.getSelectedHall()['product_id']).subscribe(value => {
          this.timesUnavaliable = value;
        });
      }

      this.resetForm();
      this.total = this.getTotal() + this.getExtras();

  }



  resetForm = (): void => {
    $('.time__item').prop('checked',false);
    this.checkedCheckboxes = [];
    this.times.forEach(item => {
      item['checked'] = false;
    });
    this.total = 0;
    this.outOfWorksTotal = 0;
    this.errorDate = false;
    this.errorTime = false;
    this.paymentMethod = 1;
    this.hiddeOrderNum = false;
  }

  checkTimeStatus = (item):boolean => {
    for (let time of this.timesUnavaliable) {
      if (time['interval'] === item['index']) {
        return false;
      }
    }
    return true;
  }

  timesOnChange = (formControlName, item): void => {
    this.errorTime = false;
    let hall = this.cart.order.getSelectedHall();
    let status = hall === null;

    if(!status){
      this.stepControlOne.get('selectedHall').setValue(hall);
    }

    if (!this.checkTimeStatus(item)) {
      return;
    }

    if(item['checked'] === true){
      const index = this.checkedCheckboxes.indexOf(item);
      if (index !== -1) {
        this.checkedCheckboxes.splice(index, 1);
      }
      item['checked'] = false;
    } else {
      this.checkedCheckboxes.push(item);
      item['checked'] = true;
    }


    this.total = this.getTotal() + this.getExtras();
  }

  setHall = (formControlName,item): void => {
    if (item.checked == null) {
      this.stepControlOne.get(formControlName).setValue(item);
      this.cart.order.setSelectedHall(item);
    } else {
      if (item.checked) {
        this.stepControlOne.get(formControlName).setValue(null);
        this.cart.order.setSelectedHall(null);

      } else {
        this.stepControlOne.get(formControlName).setValue(item);
        this.cart.order.setSelectedHall(item);

      }
      item.checked = !item.checked;
    }
  }

  validateCheckboxGroup = (): void => {
    if (this.checkedCheckboxes.length !== 0 && this.stepControlTwo.get('selectedDate').value !== null) {
      this.stepControlTwo.get('selectedTime').setValue(this.checkedCheckboxes);
      this.newTotal = this.stepControlOne.get('selectedHall').value['price'] * this.checkedCheckboxes.length;
      this.errorTime = false;
      this.errorDate = false;
      this.stepper.next();
    }

    if(this.checkedCheckboxes.length === 0){
        this.errorTime = true;
    }

    if(this.stepControlTwo.get('selectedDate').value === null){
      this.errorDate = true;
    }
    return ;
  }

  hallsOnChange = (formControlName, item): void => {
    if (item.checked == null) {
      this.stepControlOne.get(formControlName).setValue(item);
      this.cart.order.setSelectedHall(item);
      fbq('track', 'AddToCart');
    } else {
      if (item.checked) {
        this.stepControlOne.get(formControlName).setValue(null);
        this.cart.order.setSelectedHall(null);

      } else {
        this.stepControlOne.get(formControlName).setValue(item);
        this.cart.order.setSelectedHall(item);
        fbq('track', 'AddToCart');
      }
      item.checked = !item.checked;
    }

    fbq('track', 'InitiateCheckout');
    this.stepper.next();
  }

  extrasOnChange = (formControlName, item): void => {
    if (item.checked == null) {
      this.stepControlThree.get(formControlName).setValue(item);
    } else {
      if (item.checked) {
        this.stepControlThree.get(formControlName).setValue(null);
      } else {
        this.stepControlThree.get(formControlName).setValue(item);
      }
      item.checked = !item.checked;
    }
    this.total = this.getTotal() + this.getExtras();
  }

  personsChange = (formControlName, index): void => {
    let item = null;
    for (let option of this.extras.numberOfPersons) {
      if (option['index'] == index.value) {
         item = option;
      }
    }
    // this.extrasOnChange(formControlName,item);
    this.extrasOnChange('numberOfPersons',item);
  }

  changeDressingRoom = (formControlName, index): void => {
    let item = null;
    for (let option of this.extras.dressingRoom) {
      if (option['index'] == index.value) {
         item = option;
      }
    }

    this.extrasOnChange('dressingRoom', item);
  }


  getTotal = (): number => {
    let subPrice = 0;

    this.checkedCheckboxes.forEach(( item ) => {
      // if ( item.subPrice !== undefined ) {
      //   subPrice += item.subPrice;
      // }
      if([0,1,10,11,12,13,14,15,16,17,18,19,20,21,22,23].includes(item.index)) {
        subPrice += 150;
      }
    })

    this.outOfWorksTotal = subPrice;

    return this.stepControlOne.get('selectedHall').value['price'] * this.checkedCheckboxes.length  + subPrice;
  }
    getExtras = (): number => {
      let summ = 0;
      let lightSource = this.stepControlThree.get('lightSource').value;
      let dressingRoom = this.stepControlThree.get('dressingRoom').value;
      let numberOfPersons = this.stepControlThree.get('numberOfPersons').value;
      let bathFilling = this.stepControlThree.get('bathFilling').value;

      if (lightSource) {
        summ += lightSource['price'];
      }
      if (dressingRoom) {
        summ += dressingRoom['price'];
      }
      if (numberOfPersons) {
        summ += numberOfPersons['price'] * this.checkedCheckboxes.length;
      }
      if (bathFilling) {
        summ += bathFilling['price'];
      }
       return summ;

    }

  recalculateDressesCost = (selectedDresses): void => {
    let sum = 0;
    for (let item of selectedDresses) {
      sum += item['price'];
    }
    this.dressesCost = sum - this.dressesCostOld;
    this.dressesCostOld = sum;
  }

  formOrder = (): void => {

    this.cart.order.setSelectedHall(this.stepControlOne.get('selectedHall').value);

    if(this.stepControlThree.get('numberOfPersons').value === null){
      this.stepControlThree.get('numberOfPersons').setValue(this.extras.numberOfPersons[0]);
    }

    if(this.stepControlThree.get('dressingRoom').value === null){
      this.stepControlThree.get('dressingRoom').setValue(this.extras.dressingRoom[0]);
    }

    this.goForward();
    //todo implement Builder
    this.formedOrder = new Order();
    this.formedOrder.setSelectedHall(this.cart.order.getSelectedHall());
    this.formedOrder.setSelectedDate(this.stepControlTwo.get('selectedDate').value);
    this.formedOrder.setSelectedTime(this.stepControlTwo.get('selectedTime').value);
    this.formedOrder.setLightSource(this.stepControlThree.get('lightSource').value);
    this.formedOrder.setExtraDressingRoom(this.stepControlThree.get('dressingRoom').value);
    this.formedOrder.setNumberOfPersons(this.stepControlThree.get('numberOfPersons').value);
    this.formedOrder.setBathFilling(this.stepControlThree.get('bathFilling').value);
    this.formedOrder.setDress(this.selectedDresses);
    this.cart.order = this.formedOrder;
  }

  setLiq = () => {
    this.cart.order.paymentMethodId = 1;
    this.paymentChosen = true;
    this.paymentMethod = 1;
  }
  setInvoice = () => {
    this.cart.order.paymentMethodId = 2;
    this.paymentMethod = 2;
  }
  submitOrder = () => {

    setTimeout(function(){
      $('.rmenu .app-loading').css('display','flex');
      $('.rmenu .app-loading').delay(1500).fadeOut('slow');
  }, 0);


    this.cart.order.userFullName = this.subFormGroupOne.get('name').value;
    this.cart.order.userPhoneNumber = this.subFormGroupTwo.get('phone').value;
    this.cart.order.userEmail = this.subFormGroupThree.get('email').value.toLowerCase();
    this.cart.order.paymentMethodId = this.cart.order.paymentMethodId;
    this.cart.packOrder();

    let vm = this;

    if(this.cart.order.paymentMethodId === 1) {
      $('.rmenu').css('background','#fff');
       this.counter.restart();
       this.goForward();
      $('#liqpay_checkout').html('');
      this.counter.begin();
    }

    (this.apiService.sendOrder(this.cart.packOrder())).subscribe(value => {
      if(value['status'] === 200) {
        fbq('track', 'Lead');
        this.orderNumber = value['orderId'];
        if(this.cart.order.paymentMethodId === 1) {
          LiqPayCheckout.init({
            data: value['liqpay']['data'],
            signature: value['liqpay']['signature'],
            embedTo: '#liqpay_checkout',
            language: 'uk',
            mode: 'embed'
            }).on('liqpay.callback', function(data){
            // console.log(data);
            vm.counter.stop();
            vm.goForward();
            // if(data.status === 'success' || data.status === 'sandbox'){
            if(data.status === 'success'){
              $('.thank-step .text').css('color','#28a745');
              vm.payMessage = 'Бронювання підтверджено';
              fbq('track', 'Purchase', {value: this.total, currency: 'UAH'});
            } else {
              $('.thank-step .text').css('color','#dc3545');
              vm.payMessage = 'Помилка оплати.';
            }
          });
        } else {
          $('.rmenu').css('background','#fff');
          this.goForward();
          $('.thank-step .text').css('color','#28a745');
          this.payMessage = 'На вказаний email надіслано рахунок. Оплатіть його протягом 24 годин.';
        }
      } else {
        $('.thank-step .text').css('color','#dc3545');
        vm.payMessage = 'Виникли тимчасові неприємності. Зверніться до менеджера.';
        // console.log('error');
      }
    });
  }

  finishTimer() {
    $('.rmenu').removeAttr('style');
    this.moveToStep(0);
    let checkboxes = Array.from(document.getElementsByClassName('hall-checkbox'));
      for (let item of checkboxes) {
        (item as HTMLInputElement).checked = false;
      }
      this.stepControlTwo.get('selectedDate').setValue(null);
      this.stepControlOne.get('selectedHall').setValue(null);
      this.resetForm();
      this.total = this.getExtras();
  }

  acceptRules = () => {
    this.rulesAccepted = !this.rulesAccepted;
  }

  constructor(private _formBuilder: FormBuilder,
              public UIservice: UiService,
              private dressService: DressesService,
              private apiService: ApiService) {
    //   this.dressService.listenSelectedDresses().subscribe(value => {
    //   this.selectedDresses = value;
    //   this.recalculateDressesCost(value);
    //   this.total = this.total + this.dressesCost;
    // });

  }

  ngOnInit() {
    // this.apiService.getTimes({}).subscribe(value => {this.timesUnavaliable = value;console.log(this.timesUnavaliable)});
    this.halls = this.apiService.halls;
    this.stepControlOne = this._formBuilder.group({
      selectedHall: [],
    });
    this.stepControlTwo = this._formBuilder.group({
      selectedDate: ['', Validators.required],
      selectedTime: [''],
    });
    this.stepControlThree = this._formBuilder.group({
      selectedDress: [],
      lightSource: [],
      dressingRoom: [],
      numberOfPersons: [],
      bathFilling: []
    });
    this.stepControlFour = this._formBuilder.group({
      fourthCtrl: ['', Validators.required]
    });
    this.subFormGroupOne = this._formBuilder.group({
      name: ['', Validators.compose([Validators.required])]
    });
    this.subFormGroupTwo = this._formBuilder.group({
      phone: ['', Validators.compose(
        [Validators.required, Validators.pattern('^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$')]
      )]
    });
    this.subFormGroupThree = this._formBuilder.group({
      email: ['',
      Validators.compose([Validators.required,Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-z]{2,4}$')])
      ]
    });
    this.subFormGroupFour = this._formBuilder.group({
      payment: ['']
    });

    this.UIservice.listenRightMenuActiveStepIndex().subscribe(value => {
      this.stepControlTwo.get('selectedDate').setValue(null);
      this.stepControlOne.get('selectedHall').setValue(null);
      this.resetForm();
      this.total = this.getExtras();
      this.moveToStep(value);
    });
  }

  pastDate = (d: Date): boolean => {
    return moment().format('YYYY-MM-DD') <= moment(d).format('YYYY-MM-DD');
  }

  ngOnDestroy () {
    this.dressService.listenSelectedDresses().unsubscribe();
    this.UIservice.listenRightMenuActiveStepIndex().unsubscribe();
  }

}
